import { BlockAPI } from "@softr-io/blocks-sdk";

interface BlockAPIReadyDetail {
    blockName: string;
    blockVersion: string;
    api: BlockAPI | undefined;
}
export class BlockAPIReadyEvent extends CustomEvent<BlockAPIReadyDetail> {
    constructor(detail: BlockAPIReadyDetail) {
        super("@softr-io/block-api-ready", { detail });
    }
    static dispatch(detail: BlockAPIReadyDetail) {
        // We want to make sure that event listener callbacks are called asynchronously to prevent
        // them from blocking the caller.
        setTimeout(() => {
            window.dispatchEvent(new BlockAPIReadyEvent(detail));
        });
    }

    /**
     * @returns a cleanup function that removes the event listener
     */
    static listen(callback: (event: BlockAPIReadyEvent) => void): () => void {
        window.addEventListener("@softr-io/block-api-ready", callback);
        return () => {
            window.removeEventListener("@softr-io/block-api-ready", callback);
        };
    }
}
declare global {
    interface WindowEventMap {
        "@softr-io/block-api-ready": BlockAPIReadyEvent;
    }
}
